import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const ProtectedRoute = ({ children }) => {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) {
        window.location.href = '/';
      } else {
        setSession(session);
      }
    });
  }, []);

  if (!session) return null;
  return children;
};

export default ProtectedRoute;
